/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * One lane, from this carrier's point of view.
 *
 * Driven by what they *quoted*, not only by what they booked: a lane where
 * they price everything and win nothing is the most useful row in the
 * table, and a booked-only list would hide it entirely.
 *
 * `laneOpportunityShipments` is the total volume we quote on the lane,
 * including freight this carrier never priced. It discloses our lane
 * volumes, which is an accepted trade — "here is where the freight is that
 * you aren't winning" is the whole point.
 *
 * @export
 * @interface PerformanceLaneRow
 */
export interface PerformanceLaneRow {
  /**
   *
   * @type {string}
   * @memberof PerformanceLaneRow
   */
  pickup: string;
  /**
   *
   * @type {string}
   * @memberof PerformanceLaneRow
   */
  delivery: string;
  /**
   * Shipments on this lane this carrier priced.
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  quoted: number;
  /**
   * Shipments on this lane booked with this carrier.
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  booked: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  winRate: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  cheapestRate?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  averagePriceRank?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  averagePremiumWhenNotCheapest?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  averageSpend?: number;
  /**
   * Everything we quoted on this lane, whoever priced it.
   * @type {number}
   * @memberof PerformanceLaneRow
   */
  laneOpportunityShipments?: number;
}

/**
 * Check if a given object implements the PerformanceLaneRow interface.
 */
export function instanceOfPerformanceLaneRow(
  value: object,
): value is PerformanceLaneRow {
  if (!("pickup" in value) || value["pickup"] === undefined) return false;
  if (!("delivery" in value) || value["delivery"] === undefined) return false;
  if (!("quoted" in value) || value["quoted"] === undefined) return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("winRate" in value) || value["winRate"] === undefined) return false;
  return true;
}

export function PerformanceLaneRowFromJSON(json: any): PerformanceLaneRow {
  return PerformanceLaneRowFromJSONTyped(json, false);
}

export function PerformanceLaneRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceLaneRow {
  if (json == null) {
    return json;
  }
  return {
    pickup: json["pickup"],
    delivery: json["delivery"],
    quoted: json["quoted"],
    booked: json["booked"],
    winRate: json["winRate"],
    cheapestRate:
      json["cheapestRate"] == null ? undefined : json["cheapestRate"],
    averagePriceRank:
      json["averagePriceRank"] == null ? undefined : json["averagePriceRank"],
    averagePremiumWhenNotCheapest:
      json["averagePremiumWhenNotCheapest"] == null
        ? undefined
        : json["averagePremiumWhenNotCheapest"],
    averageSpend:
      json["averageSpend"] == null ? undefined : json["averageSpend"],
    laneOpportunityShipments:
      json["laneOpportunityShipments"] == null
        ? undefined
        : json["laneOpportunityShipments"],
  };
}

export function PerformanceLaneRowToJSON(json: any): PerformanceLaneRow {
  return PerformanceLaneRowToJSONTyped(json, false);
}

export function PerformanceLaneRowToJSONTyped(
  value?: PerformanceLaneRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pickup: value["pickup"],
    delivery: value["delivery"],
    quoted: value["quoted"],
    booked: value["booked"],
    winRate: value["winRate"],
    cheapestRate: value["cheapestRate"],
    averagePriceRank: value["averagePriceRank"],
    averagePremiumWhenNotCheapest: value["averagePremiumWhenNotCheapest"],
    averageSpend: value["averageSpend"],
    laneOpportunityShipments: value["laneOpportunityShipments"],
  };
}
